export interface RequestHotelRegisterInterface {
  contact_name: string;
  contact_email: string;
  contact_mobile?: string;
  phone?: string;
  hotel_name: string;
  hotel_address: string;
  prefixPhone?: string;
}
export class ResponseHotelRegister {
  contact_name: string;

  contact_email: string;

  contact_mobile: string;

  hotel_name: string;

  hotel_address: string;

  phone: string;

  prefixPhone: string;

  constructor(data: any) {
    this.contact_name = data.contact_name || "";
    this.contact_email = data.contact_email || "";
    this.contact_mobile = data.contact_mobile || "";
    this.hotel_name = data.hotel_name || "";
    this.hotel_address = data.hotel_address || "";
    this.phone = data.phone || "";
    this.prefixPhone = data.prefixPhone || "";
  }
}
